<template>
<div class="row">
    <div class="col-md-6">
        <APIList :selectedType="selectedType" :types="types" :apis="apis" :isLoaded="isLoaded" @apiChanged="loadAPI" @typeChanged="loadAPIType" />

        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item">
            <a class="page-link" href="#" @click.prevent="previousPage">Previous</a>
          </li>
          <li class="page-item">
            <a class="page-link">{{ currentPage }} / {{ pageCount }}</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" @click.prevent="nextPage">Next</a>
          </li>
        </ul>
    </div>

    <div class="col-md-6">
        <APIView :selectedType="selectedType" :api="selectedAPI" :isLoading="isLoading" @updateList="updateList" @refreshList="refreshList" @clear="clearAPI"/>
    </div>
</div>
</template>

<script>
import APIList from '@/components/settings/api/List'
import APIView from '@/components/settings/api/API'

import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory'
const APIRepo = RepositoryFactory.get('external_apis')

export default {
    name: "APIs",
    components: {
        APIList,
        APIView
    },
    data: function() {
        return {
            isLoaded: false,
            isLoading: false,

            currentPage: 1,
            totalRecords: 0,
            resultsLimit: 10,
            types: [],
            apis: [],
            selectedAPI: {},
            selectedType: 'all'
        }
    },
    async mounted() {
        await this.loadTypes()
    },
    methods: {
        loadTypes: function() {
            this.isLoaded = false
            return APIRepo.types().then(result => {
                this.types = result.data.results
                this.isLoaded = true
                return result.data.results
            }).catch(err => {
                console.log(err)
                return []
            })
        },
        loadAPIType: function(type) {
            const typeKey = (typeof type === 'object' && type !== null) ? type.type : type
            this.selectedType = typeKey
            this.selectedAPI = {}

            if (typeKey === 'all') {
                this.loadAllApis()
                return
            }

            this.isLoaded = false
            APIRepo.type(typeKey).then(result => {
                this.apis = result.data.results
                this.isLoaded = true
            }).catch(err => {
                console.log(err)
                this.isLoaded = true
            })
        },
        async loadAllApis() {
            this.isLoaded = false
            var all = []
            for (const typeEntry of this.types) {
                const typeKey = typeEntry.type || typeEntry.shortname || typeEntry.name
                if (!typeKey) continue
                try {
                    const result = await APIRepo.type(typeKey)
                    const items = (result.data.results || []).map(item => {
                        if (!item.type) item.type = typeKey
                        return item
                    })
                    all = all.concat(items)
                } catch (err) {
                    console.log(`Failed loading ${typeKey}:`, err)
                }
            }
            this.apis = all
            this.isLoaded = true
        },
        loadAPI: function(api) {
            this.selectedAPI = api
            this.selectedType = api.type || this.selectedType
        },
        clearAPI: function() {
            this.selectedAPI = {}
        },
        updateList: function(api) {
            this.apis.push(api)
        },
        refreshList: function() {
            this.loadAPIType(this.selectedType)
        }
    },
    computed: {
        pageCount: function() {
            return Math.ceil(this.totalRecords / this.resultsLimit)
        },
    },
}
</script>

<style>

</style>
